import {IconButton} from '@material-ui/core';
import React, {ReactElement} from 'react';
import styles from './NxIconButton.scss';

export interface NxIconButtonProps {
  ariaLabel?: string;
  ariaControlsId?: string;
  icon: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  className?: string;
}

const NxIconButton = (
    {ariaLabel, ariaControlsId, icon, onClick, disabled = false, className
  }: NxIconButtonProps): ReactElement => {

  const iconClasses = { root: styles.icon };

  return (
    <IconButton
      aria-label={ariaLabel}
      aria-controls={ariaControlsId}
      aria-haspopup='true'
      classes={iconClasses}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {icon}
    </IconButton>
  );
}

export default NxIconButton;
